import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 14 minutes 39 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#16a34a] text-white text-center py-1 font-semibold text-sm md:text-base shadow-sm uppercase tracking-wider" data-id="element-38">
      Oferta termina en: {formatTime(timeLeft)}
    </div>;
}